var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
var Segmented = function (_a) {
    var name = _a.name, value = _a.value, onChange = _a.onChange, options = _a.options, _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.className, className = _d === void 0 ? "" : _d, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e;
    var handleChange = function (optionValue) {
        if (!disabled) {
            onChange(optionValue);
        }
    };
    var wrapperClasses = [
        "segmented",
        "lib-segmented-".concat(size),
        disabled ? "lib-segmented-disabled" : "",
        fullWidth ? "lib-segmented-full-width" : "lib-segmented-fit-content",
        className,
    ]
        .filter(Boolean)
        .join(" ");
    return (React.createElement("div", { className: wrapperClasses, style: __assign({}, (fullWidth ? {} : { width: "auto", display: "inline-flex" })) }, options.map(function (option) {
        var isSelected = value === option.value;
        var isDisabled = disabled || option.disabled;
        var segmentId = "".concat(name, "-").concat(option.value);
        return (React.createElement("div", { key: option.value, className: "segment" },
            React.createElement("input", { type: "radio", id: segmentId, name: name, value: option.value, checked: isSelected, disabled: isDisabled, onChange: function () { return handleChange(option.value); } }),
            React.createElement("label", { htmlFor: segmentId, className: "lib-segmented-label ".concat(isDisabled ? "lib-segmented-label-disabled" : "") },
                option.icon && (React.createElement(FontAwesomeIcon, { icon: option.icon, className: "lib-segmented-icon", style: {
                        marginRight: option.label ? "8px" : "0",
                    } })),
                option.label && React.createElement("span", { className: "lib-segmented-text" }, option.label))));
    })));
};
export default Segmented;
